import * as React from 'react'
import { Elements } from '@tfo/common'
import { useIntl } from 'react-intl'

import './IndividualInformation.scss'

import personnummer from 'personnummer.js'
interface IndividualInfo {
    individualFirstName: string
    individualLastName: string
    individualEmail: string
    individualPhoneNumber: string
    individualNationalId: string
}

const IndividualInformationEditForm = ({ individualInfo }: {
    individualInfo: IndividualInfo
}) => {
    const { Label, Paragraph } = Elements
    const intl = useIntl()

    return (
        <div className='individual-info-container'>
					{individualInfo.individualNationalId &&
						<span className='national-id'>
                <Label className='label'>
                    {intl.formatMessage({ id: 'common.nationalid' })}
                </Label>
                <Paragraph>
                    {personnummer.parse(individualInfo.individualNationalId, { normaliseFormat: "YYMMDD-NNNN" }).normalised}
                </Paragraph>
            </span>
						}
            <span className='first-name'>
                <Label className='label'>
                    {intl.formatMessage({ id: 'neworder.firstname.placeholder' })}
                </Label>
                <Paragraph>
                    {individualInfo.individualFirstName}
                </Paragraph>
            </span>
            <span className='last-name'>
                <Label className='label'>
                    {intl.formatMessage({ id: 'neworder.lastname.placeholder' })}
                </Label>
                <Paragraph>
                    {individualInfo.individualLastName}
                </Paragraph>
            </span>
            <span className='email'>
                <Label className='label'>
                    {intl.formatMessage({ id: 'common.email' })}
                </Label>
                <Paragraph>
                    {individualInfo.individualEmail}
                </Paragraph>
            </span>
            {individualInfo.individualPhoneNumber && <span className='phone-number'>
                <Label className='label'>
                    {intl.formatMessage({ id: 'common.phonenumber.mobile' })}
                </Label>
                <Paragraph>
                    {individualInfo.individualPhoneNumber}
                </Paragraph>
            </span>}
        </div>
    )
}

export default IndividualInformationEditForm
